/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";
import { TokenStorage } from "../../storage";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const TransactionListService = {
  /**
   * Get Screen data
   *
   * */
  async getReportPreviewScreenName(screenName) {
    const requestScreenData = {
      url: "api/TransactionListReportPreview",
      select: [
        "AvailableForEmail",
        "AvailableForPDFPreview",
        "Parameters",
        "RecordID",
        "ReportDisplayName",
        "ScreenLayoutApplicationFeatureCode",
        "ScreenName",
        "Status",
        "TransactionCode",
      ],
      // top: "1",
      filter: `ScreenName eq '${screenName}' and Status eq 'A'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  async getReportBackgroundScreenName(screenName, params) {
    const requestScreenData = {
      url: "api/TransactionListReportBackground",
      filter: `ScreenName eq '${screenName}' and Status eq 'A'`,
    };

    if (params) {
      if (params.select) {
        requestScreenData.select = params.select;
      }
    }

    return await ApiService.oDataGet(requestScreenData);
  },

  async reportBackgroundPrintOrder(payload) {
    var url = "api/Save_ReportBackgroundPrint";
    return await ApiService.post(url, payload);
  },

  async reportBackgroundEmail(payload) {
    var url = "api/Save_ReportBackgroundEmail";
    return await ApiService.post(url, payload);
  },

  async batchPaymentListReportBackgroundEmail(payload) {
    var url = "api/Save_BatchPaymentListBackgroundEmail";
    return await ApiService.post(url, payload);
  },

  async getReportPreviewScreens() {
    const requestScreenData = {
      url: "api/TransactionListReportPreview",
      select: [
        "AvailableForEmail",
        "AvailableForPDFPreview",
        "Parameters",
        "RecordID",
        "ReportDisplayName",
        "ScreenLayoutApplicationFeatureCode",
        "ScreenName",
        "Status",
        "TransactionCode",
      ],
      filter: `Status eq 'A'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  async getReportBackgroundScreens(params) {
    const requestScreenData = {
      url: "api/TransactionListReportBackground",
      filter: `Status eq 'A'`,
    };

    if (params && params.select) {
      requestScreenData.select = params.select;
    }

    return await ApiService.oDataGet(requestScreenData);
  },
  async deleteRecord(requestScreenData) {
    return await ApiService.delete(
      "api/" + requestScreenData.url,
      requestScreenData.code,
      requestScreenData.codeType
    );
  },
};

export { TransactionListService };
